export const bbvQuery = {
  getQuery: (qid) => `
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX cti: <http://pms.coentunnelcompany.nl/instance#>
    PREFIX ct: <http://pms.coentunnelcompany.nl/rdl#>
    SELECT ?intervention ?bbvq ?qid ?name ?reason ?docid ?qname ?record ?bbv ?oldValue ?newValue
    WHERE {
      ?intervention rdf:type           ct:Intervention .
      ?intervention ct:hasName         ?name .
      ?intervention ct:quarter         <${qid}> .
      ?intervention ct:quarter         ?qid .
      ?qid          ct:hasName         ?qname .
      OPTIONAL { ?intervention   ct:isJustifiedBy   ?reason }
      OPTIONAL { ?intervention   ct:isRepresentedIn ?docid }
      ?intervention ct:appliesTo ?record .

      # bbv records:
      ?record       ct:oldSubject      ?bbv .
      ?bbv          rdf:type           ct:BrutoBeschikbaarheidsvergoeding .
      ?record       ct:oldObject       ?oldValue .
      ?record       ct:newObject       ?newValue .
      ?bbvq         ct:hasProperty     ?bbv
    } order by ?intervention ?record
  `,
  iterator: {
    name: 'intervention',
    record: 'intervention',
    reason: 'intervention',
    docid: 'intervention',
    qid: 'intervention',
    qname: 'qid',
    bbv: 'record',
    bbvq: 'record',
    oldValue: 'record',
    newValue: 'record'
  },
  root: 'intervention'
}

export const waardeDagQuery = {
  getQuery: (qid) => `
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX cti: <http://pms.coentunnelcompany.nl/instance#>
    PREFIX ct: <http://pms.coentunnelcompany.nl/rdl#>
    SELECT ?intervention ?qid ?name ?reason ?docid ?qname ?record ?waarde ?oldValue ?newValue
    WHERE {
      ?intervention rdf:type           ct:Intervention .
      ?intervention ct:hasName         ?name .
      ?intervention ct:quarter         <${qid}> .
      ?intervention ct:quarter         ?qid .
      ?qid          ct:hasName         ?qname .
      OPTIONAL { ?intervention   ct:isJustifiedBy   ?reason }
      OPTIONAL { ?intervention   ct:isRepresentedIn ?docid }
      ?intervention ct:appliesTo ?record .

      # waarde records:
      ?record       ct:oldSubject      ?waarde .
      ?waarde       rdf:type           ct:WaardeDag .
      ?record       ct:oldObject       ?oldValue .
      ?record       ct:newObject       ?newValue .
    } order by ?intervention ?record
  `,
  iterator: {
    name: 'intervention',
    record: 'intervention',
    reason: 'intervention',
    docid: 'intervention',
    qid: 'intervention',
    qname: 'qid',
    waarde: 'record',
    oldValue: 'record',
    newValue: 'record'
  },
  root: 'intervention'
}

export const waardeNachtQuery = {
  getQuery: (qid) => `
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX cti: <http://pms.coentunnelcompany.nl/instance#>
    PREFIX ct: <http://pms.coentunnelcompany.nl/rdl#>
    SELECT ?intervention ?qid ?name ?reason ?docid ?qname ?record ?waarde ?oldValue ?newValue
    WHERE {
      ?intervention rdf:type           ct:Intervention .
      ?intervention ct:hasName         ?name .
      ?intervention ct:quarter         <${qid}> .
      ?intervention ct:quarter         ?qid .
      ?qid          ct:hasName         ?qname .
      OPTIONAL { ?intervention   ct:isJustifiedBy   ?reason }
      OPTIONAL { ?intervention   ct:isRepresentedIn ?docid }
      ?intervention ct:appliesTo ?record .

      # waarde records:
      ?record       ct:oldSubject      ?waarde .
      ?waarde       rdf:type           ct:WaardeNacht .
      ?record       ct:oldObject       ?oldValue .
      ?record       ct:newObject       ?newValue .
    } order by ?intervention ?record
    } order by ?intervention ?record
  `,
  iterator: {
    name: 'intervention',
    record: 'intervention',
    reason: 'intervention',
    docid: 'intervention',
    qid: 'intervention',
    qname: 'qid',
    waarde: 'record',
    oldValue: 'record',
    newValue: 'record'
  },
  root: 'intervention'
}

export const afsluitingenQuery = {
  getQuery: (qid) => `
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX cti: <http://pms.coentunnelcompany.nl/instance#>
    PREFIX ct: <http://pms.coentunnelcompany.nl/rdl#>
    SELECT ?intervention ?name ?qid ?reason ?docid ?qname ?record ?lcr ?rlc ?incident
    WHERE {
      ?intervention rdf:type           ct:Intervention .
      ?intervention ct:hasName         ?name .
      ?intervention ct:quarter         <${qid}> .
      ?intervention ct:quarter         ?qid .
      ?qid          ct:hasName         ?qname .
      OPTIONAL { ?intervention   ct:isJustifiedBy   ?reason }
      OPTIONAL { ?intervention   ct:isRepresentedIn ?docid }
      ?intervention ct:appliesTo ?record .

      # afsluiting records:
      ?lcr          ct:hasAsResult     ?rlc .
      ?record       ct:newSubject      ?rlc .
      ?rlc          rdf:type           ct:RequestedLaneClosure .
      ?record       ct:newObject       ?incident .
    } order by ?intervention ?record
  `,
  iterator: {
    name: 'intervention',
    record: 'intervention',
    reason: 'intervention',
    docid: 'intervention',
    qid: 'intervention',
    qname: 'qid',
    lcr: 'record',
    rlc: 'record',
    incident: 'record'
  },
  root: 'intervention'
}

export const bugfixQuery = {
  getQuery: (qid) => `
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
    PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
    PREFIX cti: <http://pms.coentunnelcompany.nl/instance#>
    PREFIX ct: <http://pms.coentunnelcompany.nl/rdl#>
    SELECT ?intervention ?name ?qid ?reason ?docid ?qname ?record ?oldSubject ?oldPredicate ?oldObject ?newSubject ?newPredicate ?newObject
    WHERE {
      ?intervention rdf:type           ct:Intervention .
      ?intervention ct:hasName         ?name .
      ?intervention ct:quarter         <${qid}> .
      ?intervention ct:quarter         ?qid .
      ?qid          ct:hasName         ?qname .
      OPTIONAL { ?intervention   ct:isJustifiedBy   ?reason }
      OPTIONAL { ?intervention   ct:isRepresentedIn ?docid }
      ?intervention ct:appliesTo ?record .

      OPTIONAL { ?record ct:oldSubject ?oldSubject }
      OPTIONAL { ?record ct:oldPredicate ?oldPredicate }
      OPTIONAL { ?record ct:oldObject ?oldObject }
      OPTIONAL { ?record ct:newSubject ?newSubject }
      OPTIONAL { ?record ct:newPredicate ?newPredicate }
      OPTIONAL { ?record ct:newObject ?newObject }

      # bbv records:
      MINUS {
        ?record       ct:oldSubject      ?bbv .
        ?bbv          rdf:type           ct:BrutoBeschikbaarheidsvergoeding .
      }

      # afsluiting records
      MINUS {
        ?record       ct:newSubject      ?rlc .
        ?rlc          rdf:type           ct:RequestedLaneClosure .
      }

    } order by ?intervention ?record
  `,
  iterator: {
    name: 'intervention',
    record: 'intervention',
    reason: 'intervention',
    docid: 'intervention',
    qid: 'intervention',
    qname: 'qid',
    oldSubject: 'record',
    oldPredicate: 'record',
    oldObject: 'record',
    newSubject: 'record',
    newPredicate: 'record',
    newObject: 'record'
  },
  root: 'intervention'
}
